import { useTranslation } from 'react-i18next';
import { FadeUp, Stagger, StaggerItem } from '../components/Motion';
import Counter from '../components/Counter';
import { TreeDeciduous, Users, Coins } from 'lucide-react';

export default function Impact() {
  const { t } = useTranslation();
  const blocks = [
    { Icon: TreeDeciduous, k: 'env', img: 'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/syufiggb_IMG_7103.jpeg' },
    { Icon: Users, k: 'social', img: 'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/ii7pxtng_IMG_7088.jpeg' },
    { Icon: Coins, k: 'eco', img: 'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/f4phi0a7_IMG_7102.jpeg' },
  ];

  return (
    <main data-testid="impact-page" className="pt-32">
      <section className="container-x max-w-7xl mx-auto pb-16">
        <FadeUp>
          <p className="overline">{t('impact.overline')}</p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl text-ink tracking-tight max-w-4xl text-balance">
            {t('impact.title')}
          </h1>
          <p className="mt-6 text-lg text-ink-soft max-w-2xl leading-relaxed">{t('impact.intro')}</p>
        </FadeUp>
      </section>

      <section className="bg-sand/50 py-20">
        <div className="container-x max-w-7xl mx-auto grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {[
            { v: 19, s: '+', label: 'years' },
            { v: 48, s: 't', label: 'tons' },
            { v: 2, s: '', label: 'certifications' },
            { v: 60, s: '+', label: 'beneficiaries' },
          ].map((it) => (
            <FadeUp key={it.label} className="border-l-2 border-earth pl-5">
              <div className="font-heading text-5xl text-forest"><Counter value={it.v} suffix={it.s} /></div>
              <div className="mt-2 text-xs uppercase tracking-widest text-ink-muted">{t(`home.stats.${it.label}`)}</div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="container-x max-w-7xl mx-auto py-24">
        <Stagger className="grid gap-16">
          {blocks.map((b, i) => {
            const reverse = i % 2 === 1;
            return (
              <StaggerItem key={b.k}>
                <div className="grid gap-10 lg:grid-cols-12 items-center">
                  <div className={`lg:col-span-6 ${reverse ? 'lg:order-2' : ''}`}>
                    <div className="aspect-[4/3] rounded-3xl overflow-hidden">
                      <img src={b.img} alt="" className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <div className={`lg:col-span-6 ${reverse ? 'lg:order-1' : ''}`}>
                    <div className="w-14 h-14 grid place-items-center rounded-2xl bg-forest/8 text-forest mb-5">
                      <b.Icon size={26} strokeWidth={1.6} />
                    </div>
                    <h2 className="font-heading text-3xl sm:text-4xl text-ink tracking-tight">{t(`impact.${b.k}_title`)}</h2>
                    <p className="mt-4 text-ink-soft text-lg leading-relaxed">{t(`impact.${b.k}_text`)}</p>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </section>
    </main>
  );
}
